export default __webpack_public_path__ + "static/email-pdf-example-79f5e6ca9f1580f1c79b865a3cfd746d.png";